import orderBy from "lodash.orderby";
import { SortDirection, GroupBy } from "./types";

type SortFunction = (
  groups: Insite.Insights.ComposedInsight[][],
  direction?: SortDirection
) => Insite.Insights.ComposedInsight[][];

export const sortByHits: SortFunction = (groups) => {
  return orderBy(
    groups,
    (g) => g.reduce((hits, rule) => hits + rule.activeHits, 0),
    "desc"
  );
};

export const sortByEquips: SortFunction = (groups) => {
  return orderBy(
    groups,
    (g) => g.reduce((total, rule) => total + rule.targetCount, 0),
    "desc"
  );
};

export const sortByInsights: SortFunction = (groups, direction) => {
  return orderBy(groups, (g) => g.length, direction);
};

export function sortByAlpha(
  groups: Array<Insite.Insights.ComposedInsight[]>,
  groupBy: GroupBy,
  direction: SortDirection
) {
  if (groupBy === GroupBy.Rule) {
    return orderBy(groups, (g) => `${g[0].ruleName}`.toLowerCase(), direction);
  }

  if (groupBy === GroupBy.Site) {
    return orderBy(
      groups,
      (g) => `${g[0].site.label}`.toLowerCase(),
      direction
    );
  }

  if (groupBy === GroupBy.Priority) {
    return orderBy(groups, (g) => `${g[0].priority}`.toLowerCase(), direction);
  }

  return groups;
}
